import React from 'react';
import isEmpty from 'lodash/isEmpty';

function Component(props) {
    const {
        label = '',
    } = props;

    const {
        name = label,
        placeholder = '',
        autoComplete = '',
        options = [],
        value = '',
        error = '',
        onChange
    } = props;

    const hasError = !isEmpty(error);
    const classes = hasError ? 'radio is-invalid' : 'radio';
    const type = 'radio';

    return (
        <div className='form-group inline-block'>
            {   
                options.map(x=> {
                    const checked = value === x.value;
                    return (
                        <div className="form-check form-check-inline inline-block mr-5" key={x.value}>
                            <input 
                                id={`${name}-${x.value}`}
                                name={`${name}-${x.value}`}
                                type={type}
                                className={classes}
                                placeholder={placeholder}
                                autoComplete={autoComplete}
                                value={x.value}
                                checked={checked}
                                onChange={(event) => onChange(event.target.value)}
                            />
                            <span htmlFor={`${name}-${x.value}`}>&nbsp;{x.key}</span>
                        </div>
                    );
                })
            }
            <div className="invalid-feedback">
                {error}
            </div>
        </div>
    );
}

export default Component;